import { render, staticRenderFns } from "./FshopCard.vue?vue&type=template&id=34520a0c&scoped=true&lang=pug"
import script from "./FshopCard.vue?vue&type=script&lang=js"
export * from "./FshopCard.vue?vue&type=script&lang=js"
import style0 from "./FshopCard.vue?vue&type=style&index=0&id=34520a0c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34520a0c",
  null
  
)

export default component.exports